/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * CategoryForm.ts
 */

import {AbstractForm} from "../../tools/model/form/AbstractForm";
import {AbstractDTO} from "../../tools/model/dto/AbstractDTO";

export default class EmptyForm extends AbstractForm<AbstractDTO> {

    constructor(dto?: AbstractDTO) {
        super();

        if (dto) super.load(dto);
    }
}
